// extracted by mini-css-extract-plugin
module.exports = {"icon":"SelectProducts_icon__fF8zH","butText":"SelectProducts_butText__tDSh_","butWrapper":"SelectProducts_butWrapper__w_cZH","singleButton":"SelectProducts_singleButton__24ve_"};